//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BindsAttrs } from '@/mixins'

export default {
  mixins: [ BindsAttrs ],
  props: {
    cardProps: {
      type: Object,
      default: () => {}
    },
    cardTextStyle: {
      type: String,
      default: ''
    },
    showGirl: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: false
    },
    // In the modal designs, the largest I saw was 548 so I went with this number
    maxWidth: {
      type: [ Number, String ],
      default: 548
    }
  },
  computed: {
    hasHeaderSlot () {
      return this.$slots.header || this.$slots['header-outer']
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
      this.$emit('close')
    }
  }
}
